import { Controller } from "@hotwired/stimulus";

import { trackView } from "../utils/recommender";

// Connects to data-controller="recommender-view-tracking"
export default class extends Controller {
  static values = { subKind: String, url: String, meta: Object };

  connect() {
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.handleView();
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    this.observer.observe(this.element);
  }

  disconnect() {
    this.observer.disconnect();
  }

  handleView() {
    trackView(this.subKindValue, this.urlValue, this.metaValue);
  }
}
